<app-restoration-instruction [modal]="modal"></app-restoration-instruction>
